<template>
	<div class="lb">
		<!-- <div class="text-area" ref="content" @mouseenter="mouseenterEvent()" @mouseleave="mouseleaveEvent()"> -->
			<div class="list-content" ref="scroll1" v-if="scopelist && scopelist.length">
				<div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
					<div class="lt-left-title">
						<p>{{ item.value1 }}</p>
					</div>
					<div class="lt-left-head">
						<p>{{ item.value2 }}</p>
						<div class="area2-title">{{ item.value3 }}</div>
					</div>
					<div class="bottom-area">
						<div class=line></div>
						<div class="bottom-active" :title="`${item.value3}%`"
							:style="{ width: (+item.value3 / +scopelist[0].value3 * 100) + '%' }">
							<div class="bottom-border"></div>
						</div>
					</div>
					<div class="lt-left-head1">
						<p>{{ item.value4 }}</p>
						<div class="area2-title">{{ item.value5 }}</div>
					</div>
					<div class="bottom-area2">
						<div class=line></div>
						<div class="bottom-active" :title="`${item.value5}%`"
							:style="{ width: (+item.value5 / +scopelist[0].value5 * 100) + '%' }">
							<div class="bottom-border"></div>
						</div>
					</div>
				</div>
			</div>
		<!-- </div> -->
	</div>
</template>


<script>
import * as methods from './method.js'
export default {
	name: "template.scope36",
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '数值条形图-scope36',
			timer: null,
			defaultdata: [
				{ value1: '单位:%', value2: '系列一', value3: '100', value4: '系列二', value5: '100' },
				{ value1: '单位:%', value2: '系列一', value3: '70', value4: '系列二', value5: '90' },
				{ value1: '单位:%', value2: '系列一', value3: '50', value4: '系列二', value5: '80' },
				{ value1: '单位:%', value2: '系列一', value3: '30', value4: '系列二', value5: '70' },
				{ value1: '单位:%', value2: '系列一', value3: '10', value4: '系列二', value5: '60' },
			],
			valueMap: [
				{ name: '单位', key: "value1" },
				{ name: '名称一', key: "value2" },
				{ name: '数值一', key: "value3" },
				{ name: '名称二', key: "value4" },
				{ name: '数值二', key: "value5" },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			scopelist: [],
		};
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.Drawdata()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		rollUp(t) {
			const ulf1 = this.$refs.scroll1
			const box = this.$refs.content
			if (ulf1.offsetHeight > 200) {
				box.scrollTop = 0
				this.timer = window.setInterval(this.rollStart, t)
			}
		},
		rollStart() {
		},
		mouseenterEvent() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
		mouseleaveEvent(t) {
			if (!this.timer) {
				this.timer = setInterval(this.rollStart, 150);
			}
		},
		Drawdata() {
			let linedata = JSON.parse(JSON.stringify(this.defaultdata))
			linedata = linedata.sort((a, b) => +b.value3 - +a.value3).slice(0, 10)
			this.scopelist = linedata
		},
	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.$nextTick(() => {
			this.Drawdata(); //需要刷新的数据
		});
	}
};
</script>

<style scoped lang="scss">
.lb {
	width: 435px;
	height: 240px;
    padding: 10px 0;
	display: flex;
	position: relative;
	overflow: hidden;
}
.cmain {
	width: 100%;
	height: 100%;
}

.lt-left-item {
	width: 435px;
	height: 45px;
	margin-bottom: 1px;
	// background: #000;
	position: relative;
}

.lt-left-title {
	position: absolute;
	left: 10px;
	top: 26px;

	p {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #979AA0;
		line-height: 15px;
	}
}

.lt-left-head {
	position: absolute;
	left: 94px;
	top: -4px;
	width: 160px;
	display: flex;

	// align-items: center;
	>p {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 12px;
		color: #6087D0;
		line-height: 30px;
		letter-spacing: 2px;
	}

	.head-value {
		margin-left: auto;
		color: #FAEC00;
	}
}

.bottom-area {
	position: absolute;
	left: 90px;
	top: 28px;
	width: 160px;
	background: #223d66;
	// border-radius: 10px;
	height: 15px;
	position: relative;

	.line {
		position: absolute;
		left: -10px;
		top: 0px;
		width: 4px;
		height: 15px;
		background: #137CFC;
	}

	.bottom-active {
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;


	}

	.bottom-border {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-right: 3px solid #c0dbff;
		animation: name duration timing-function delay iteration-count direction fill-mode;
		background: linear-gradient(to right, #1f6397, #119ce0 60%, #0da3e8);
		animation: borderactive 7.5s infinite linear;
	}
}

.area2-title {
	width: 180px;
	height: 15px;
	position: absolute;
	left: 60px;
	top: 31px;
	z-index: 300;
	cursor: pointer;
}

.lt-left-head1 {
	position: absolute;
	right: 20px;
	top: -4px;
	width: 160px;
	display: flex;

	// align-items: center;
	>p {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 12px;
		color: #45AFD1;
		line-height: 30px;
		letter-spacing: 2px;
	}

	.head-value {
		margin-left: auto;
		color: #FAEC00;
	}
}

.bottom-area2 {
	position: absolute;
	left: 250px;
	top: 13px;
	width: 160px;
	background: #223d66;
	// border-radius: 10px;
	height: 15px;
	position: relative;


	.line {
		position: absolute;
		right: -10px;
		top: 0px;
		width: 4px;
		height: 15px;
		background: #137CFC;
	}

	.bottom-active {
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	.bottom-border {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-right: 3px solid #c0dbff;
		animation: name duration timing-function delay iteration-count direction fill-mode;
		background: linear-gradient(to right, #378580, #54e6a0 60%, #5affa4);
		animation: borderactive 7.5s infinite linear;
	}
}


@keyframes borderactive {
	0% {
		width: 0%;
	}

	33% {
		width: 100%;
	}

	100% {
		width: 100%;
	}
}

.text-area {
	height: 240px;
	pointer-events: auto;
	width: 100%;
	// overflow-y: auto;

	// &::-webkit-scrollbar {
	// 	width: 0;
	// }
}
</style>